/** Rotas cujo último segmento é um segredo de uso único (convite, reset de senha). */
const SECRET_ROUTES = /^(\/(?:invite|password-reset))\/[^/]+/;

/**
 * URL que vai para o Google Analytics (`page_location`).
 *
 * O `gtag('config')` manda a URL inteira, e com o roteamento por hash isso
 * inclui o token do convite (`#/invite/<token>`), o hash do reset de senha e
 * o `?userData=` do "acessar como cliente" — que carrega o JWT. Fica a rota,
 * com o segredo trocado por `:token` e sem query string.
 */
export function analyticsLocation(href: string): string {
  const [base, hash = ''] = href.split('#');
  const route = hash.split('?')[0].replace(SECRET_ROUTES, '$1/:token');

  return base.split('?')[0] + (route ? `#${route}` : '');
}
